import React from 'react';
import { convertDate } from '../../helpers/dateFormat';
import InfoLabel, { DATE_HELP } from '../../../components/data/info-label.jsx';

// Empty cells show "-" instead of nothing.
const EMPTY = '-'
const orEmpty = (value) => (value === null || value === undefined || value === '' ? EMPTY : value)
const dateOrEmpty = (value) => (value ? convertDate(String(value)) : EMPTY)
// import styles from '../../../styles/page.scss'

const
    quotationStatus =
    {
        1: "New",
        2: "Replied",
        3: "Request Visual",
        4: "Visual Received",
        5: "Cancelled",
        6: "Approved"
    }

export const QuoteKanabanColum = [
    { key: 1, title: 'New' },
    { key: 2, title: 'Replied' },
    { key: 3, title: 'Request Visual' },
    { key: 4, title: 'Visual Received' },
    { key: 5, title: 'Cancelled' },
    { key: 6, title: 'Approved' },

]


export const QuoteColumn = [
    {
        title: 'Project Id',
        dataIndex: 'project_item',
        render: (project_item) => orEmpty(project_item?.global_project_id)
    },
    {
        title: <InfoLabel label="Received Date" info={DATE_HELP.quoteReceived} />,
        dataIndex: 'createdAt',
        render: dateOrEmpty
    },
    {
        title: <InfoLabel label="Deadline Delivery Date" info={DATE_HELP.deadlineDelivery} />,
        dataIndex: 'expected_delivery_date',
        render: dateOrEmpty
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: status => orEmpty(quotationStatus[status]),

    }

]